require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
	'flickity'
], function(
	$,
	mbiImageSize,
	mbiMq,
	flickity
	) {

	'use strict';

	function initFlickity() {
		if($('.menus').length>0 && !carteSlider && 'portrait-' in mbiMq.mqArea){
			carteSlider = new flickity( '.menus', {
				cellSelector: '.slide',
				pageDots: true,
				wrapAround: true,
				prevNextButtons: false,
				watchCSS: false,
				adaptiveHeight: true,
				dragThreshold: 20
			});
		} else if (carteSlider && 'landscape+' in mbiMq.mqArea) {
			carteSlider.destroy();
			carteSlider = false;
		}
	}

	var carteSlider = false;
	initFlickity();
	$(document).on('breakpoint', function(){
		initFlickity();
	});

});
define("root/Assets/Templates/Html/Menus/Js/Menus", function(){});

